// extracted by mini-css-extract-plugin
export default {"formContent":"style_formContent__XDyLV"};